import {
  getDownloadURL,
  ref,
  storage,
  uploadBytes,
  messaging,
  getToken,
} from "../firebase.web";
import { deleteObject } from "firebase/storage";

// Type definition for files
export type File = {
  uri: string;
  name: string;
  mimeType: string;
  uploaded?: boolean;
};

export const generateThumbnail = async (videoSource: string) => {
  // For web, we'll return the video source as thumbnail
  // In a real implementation, you might want to use a video processing library
  return videoSource;
};

export const uploadMediaAsync = async (
  uri: string,
  type: "image" | "video",
  companyId: string,
) => {
  try {
    if (!companyId) {
      throw new Error("Company ID is required");
    }

    const response = await fetch(uri);
    const blob = await response.blob();
    const fileRef = ref(
      storage,
      `${type}s/${companyId}/${Date.now()}-${Math.random()}.${type === "image" ? "jpg" : "mp4"}`,
    );
    await uploadBytes(fileRef, blob);
    return getDownloadURL(fileRef);
  } catch (error) {
    console.error(error);
    throw new Error("Не удалось загрузить файл");
  }
};

export const getNotificationToken = async () => {
  return getToken(messaging, {
    vapidKey: process.env.EXPO_PUBLIC_FIREBASE_WEB_PUSH_CERTIFICATE_KEY,
  });
};

export const requestUserPermission = () => {
  return Notification.requestPermission();
};

export const uploadFiles = async (
  files: File[],
  companyId: string,
): Promise<File[]> => {
  if (!files || files.length === 0) return [];

  const uploadedFiles = await Promise.all(
    files.map(async (file) => {
      console.log("file", file);
      // Если файл уже загружен (мы сами установили этот флаг)
      if (file.uploaded) {
        return file;
      }

      try {
        // Генерация пути
        const filePath = `files/${companyId}/${Date.now()}_${file.name}`;
        const storageRef = ref(storage, filePath);

        // Чтение файла как Blob
        const response = await fetch(file.uri);
        const fileBlob = await response.blob();

        // Загрузка в Firebase Storage
        await uploadBytes(storageRef, fileBlob);
        const downloadUrl = await getDownloadURL(storageRef);

        console.log("url", downloadUrl);
        // Возврат файла с обновлённым URL и флагом uploaded
        return {
          ...file,
          uri: downloadUrl,
          uploaded: true,
        };
      } catch (error) {
        console.error("Ошибка загрузки файла:", error);
        return null;
      }
    }),
  );

  return uploadedFiles.filter((f): f is File => f !== null);
};

export const uploadAvatar = async (
  uri: string,
  companyId: string,
): Promise<string> => {
  if (!companyId) {
    throw new Error("Company ID is required");
  }

  const response = await fetch(uri);
  const avatarBlob = await response.blob();
  const avatarRef = ref(storage, `avatars/${companyId}/avatar.png`);
  await uploadBytes(avatarRef, avatarBlob);
  return getDownloadURL(avatarRef);
};

export const deleteAvatar = async (companyId: string): Promise<void> => {
  if (!companyId) {
    throw new Error("Company ID is required");
  }

  const avatarRef = ref(storage, `avatars/${companyId}/avatar.png`);
  await deleteObject(avatarRef);
};

export const deleteFileByUrl = async (url: string): Promise<void> => {
  const fileRef = ref(storage, url);
  await deleteObject(fileRef);
};
